import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from './user.model';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    private baseUrl = environment.apiUrl + '/users';

    constructor(private http: HttpClient) { }

    getUsers(page: number = 1, limit: number = 20, search: string = ''): Observable<any> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('limit', limit.toString());
        if (search) {
            params = params.set('search', search);
        }
        return this.http.get<any>(this.baseUrl, { params });
    }

    getUser(id: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/${id}`);
    }

    createUser(user: User): Observable<any> {
        return this.http.post<any>(this.baseUrl, user);
    }

    updateUser(id: string, user: Partial<User>): Observable<any> {
        return this.http.patch<any>(`${this.baseUrl}/${id}`, user);
    }

    deleteUser(id: string): Observable<any> {
        return this.http.delete<any>(`${this.baseUrl}/${id}`);
    }

    getRoles(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/roles`);
    }
}
